import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { FirebaseProvider } from './components/firebase/Firebase';
import { queryClient } from './services/queryClient';
import { theme } from './theme';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <FirebaseProvider>
          <App />
        </FirebaseProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
